"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseCapability = void 0;
var WarehouseCapability;
(function (WarehouseCapability) {
    WarehouseCapability["INTERNATIONAL_SHIPPING"] = "internationalShipping";
    WarehouseCapability["SFP_ENABLED"] = "sfpEnabled";
    WarehouseCapability["INBOUNDS_ENABLED"] = "inboundsEnabled";
    WarehouseCapability["MULTIPLE_BARCODE_ENABLED"] = "multipleBarcodeEnabled";
    WarehouseCapability["ARCHIVED"] = "archived";
    WarehouseCapability["IS_CROSS_DOCK"] = "isCrossDock";
    WarehouseCapability["IS_HUB"] = "isHub";
    WarehouseCapability["IS_PREP"] = "isPrep";
    WarehouseCapability["CAN_TAKE_MEASUREMENTS"] = "canTakeMeasurements";
    WarehouseCapability["LABEL_ENABLED"] = "labelEnabled";
    WarehouseCapability["DEEP_STORAGE"] = "isDeepStorage";
    WarehouseCapability["STORAGE_INBOUNDS_ENABLED"] = "storageInboundsEnabled";
    WarehouseCapability["SUPPORTS_EXPIRATION_DATE"] = "supportsExpirationDate";
    WarehouseCapability["EVENTS_SERVICE_ENABLED"] = "eventsServiceEnabled";
    WarehouseCapability["SUPPORTS_BRANDED_PACKAGING_HIGH_TOUCH"] = "supportsBrandedPackagingHighTouch";
    WarehouseCapability["SUPPORTS_BRANDED_PACKAGING_LOW_TOUCH"] = "supportsBrandedPackagingLowTouch";
    WarehouseCapability["ENABLED"] = "enabled";
})(WarehouseCapability = exports.WarehouseCapability || (exports.WarehouseCapability = {}));
//# sourceMappingURL=WarehouseCapability.js.map